module.exports = __webpack_public_path__ + "img/star.b02ca7fa.png";